import { PaymentOptions } from '@received/pricing-model';
import { PaymentMethodOptions } from '../../../types/generalTypes';
import { PricingTermsSettings } from './settingsTypes';

export const stripeSettings: PricingTermsSettings = {
	isStripeSelectDisplayed: true,
	isStripeCardsSelectDisplayed: true,
	isStripeSelectDisabled: false,
	isStripeMethodSelected: true,
	isStripeMethodDisabled: false,

	isBanksSelectDisplayed: false,
	isBankMethodSelected: false,
	isBanksSelectDisabled: false,
	isBankMethodDisabled: false,

	isAutoChargeToggleOn: false,
	isAutoChargeToggleDisabled: false,

	isCryptoSettingsDisabled: false,

	showAutoChargeOnTooltip: false,
	showDueUponUsageTooltip: false,
};

export const bankTransferSettings: PricingTermsSettings = {
	isStripeSelectDisplayed: false,
	isStripeCardsSelectDisplayed: false,
	isStripeSelectDisabled: false,
	isStripeMethodSelected: false,
	isStripeMethodDisabled: false,

	isBanksSelectDisplayed: true,
	isBankMethodDisabled: false,
	isBanksSelectDisabled: false,
	isBankMethodSelected: true,

	isAutoChargeToggleOn: false,
	isAutoChargeToggleDisabled: false,

	isCryptoSettingsDisabled: false,

	showAutoChargeOnTooltip: false,
	showDueUponUsageTooltip: false,
};

export const autoChargeSettings: PricingTermsSettings = {
	isStripeSelectDisplayed: true,
	isStripeSelectDisabled: false,
	isStripeCardsSelectDisplayed: true,
	isStripeMethodSelected: true,
	isStripeMethodDisabled: false,

	isBanksSelectDisplayed: false,
	isBanksSelectDisabled: false,
	isBankMethodSelected: false,
	isBankMethodDisabled: true,

	isAutoChargeToggleOn: true,
	isAutoChargeToggleDisabled: false,

	isCryptoSettingsDisabled: true,

	showAutoChargeOnTooltip: true,
	showDueUponUsageTooltip: false,
};

export const dueUponUsageSettings: PricingTermsSettings = {
	isStripeSelectDisplayed: true,
	isStripeCardsSelectDisplayed: true,
	isStripeSelectDisabled: true,
	isStripeMethodSelected: true,
	isStripeMethodDisabled: true,

	isBanksSelectDisabled: true,
	isBankMethodDisabled: true,
	isBanksSelectDisplayed: false,
	isBankMethodSelected: false,

	isAutoChargeToggleOn: true,
	isAutoChargeToggleDisabled: true,

	isCryptoSettingsDisabled: true,

	showAutoChargeOnTooltip: false,
	showDueUponUsageTooltip: true,
};

export const bankTransferWithStripeSettings: PricingTermsSettings = {
	isStripeSelectDisplayed: true,
	isStripeCardsSelectDisplayed: true,
	isStripeSelectDisabled: false,
	isStripeMethodSelected: true,
	isStripeMethodDisabled: false,

	isBanksSelectDisplayed: true,
	isBankMethodDisabled: false,
	isBanksSelectDisabled: false,
	isBankMethodSelected: true,

	isAutoChargeToggleOn: false,
	isAutoChargeToggleDisabled: false,

	isCryptoSettingsDisabled: false,

	showAutoChargeOnTooltip: false,
	showDueUponUsageTooltip: false,
};

/**
 * Maps a set of selected payment options to its pricing-terms {@link PricingTermsSettings} and the
 * corresponding {@link PaymentMethodOptions} list. Pure: the caller owns any side-effects (bank
 * pre-selection) and special cases (e.g. DUE_UPON_USAGE) on top of this. Shared by PricingTerms and
 * CreateCustomer's Configurations so the core mapping can't drift between them.
 */
export const getInitialPricingTermsSettings = (
	paymentOptions?: PaymentOptions[],
): { settings?: PricingTermsSettings; methods: PaymentMethodOptions[] } => {
	let methods: PaymentMethodOptions[] = [];
	let settings: PricingTermsSettings | undefined;

	if (paymentOptions?.includes(PaymentOptions.BANK_TRANSFER)) {
		settings = bankTransferSettings;
		methods = [...methods, PaymentMethodOptions.BANK_TRANSFER];
	}
	if (paymentOptions?.includes(PaymentOptions.PAYMENT_LINK)) {
		settings = paymentOptions.includes(PaymentOptions.BANK_TRANSFER) ? bankTransferWithStripeSettings : stripeSettings;
		methods = [...methods, PaymentMethodOptions.PAYMENT_LINK];
	}
	if (paymentOptions?.includes(PaymentOptions.AUTO_CHARGE)) {
		// Auto-charge is mutually exclusive with bank transfer (autoChargeSettings disables the bank method),
		// so this deliberately replaces `methods` rather than appending — any BANK_TRANSFER added above is dropped.
		settings = autoChargeSettings;
		methods = [PaymentMethodOptions.AUTO_CHARGE, PaymentMethodOptions.PAYMENT_LINK];
	}

	return { settings, methods };
};
